import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import Select from '../../commonComponents/util/Select';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import { formatDateForInput, deepEquals, stripCurrencyFormat, formatCurrency } from '../../../lib/utils';
import { CampaignStatuses } from '../../../lib/systemVariables';

const initialState = {
    campaign: {},
    error: false,
    submitAttempted: false
};

export default class EditCampaignModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = initialState;

        this.onChange = this.onChange.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.campaign && nextProps.campaign.campaignId !== this.state.campaign.campaignId) {
            this.setState({ campaign: nextProps.campaign });
        }
    }

    onChange(name, value) {
        this.setState({ campaign: { ...this.state.campaign, ...{ [name]: value } } });
    }

    async onUpdate() {
        this.setState({ error: false, submitAttempted: true });

        const { isIsraeli, maxAmountDollar, maxAmountShekel, ...campaign } = this.state.campaign;        
        campaign.maxAmount = isIsraeli ? maxAmountShekel : maxAmountDollar;

        if (!campaign.endDate || !campaign.approverId
            || !campaign.maxAmount) {
            return;
        }

        await this.props.updateCampaign(campaign);

        if (this.props.success) {
            this.onClose();
        } else {
            this.setState({ error: true });
        }
    }

    onClose() {
        this.props.close();
        this.setState(initialState);
    }

    render() {
        const { campaign } = this.state;

        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">{campaign.status === CampaignStatuses.Open ? "Edit" : "Extend"} {campaign.name} Campaign</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<input type="date" format="mm/dd/yyyy" min={formatDateForInput(campaign.dateCreated)} max="9999-12-31"/>}
                                        label="End Date" name="endDate" value={formatDateForInput(campaign.endDate)} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                                <div className="column-half">
                                    {campaign.status === CampaignStatuses.Open && <ValidatedInput input={<Select options={this.props.approvers} />}
                                        label="Approver" name="approverId" value={campaign.approverId} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />}
                                </div>
                            </div>
                        </div>
                        {campaign.status === CampaignStatuses.Open && <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<CurrencyFormatInput isIsraeli={campaign.isIsraeli} />}
                                        label="Max Amount" name={campaign.isIsraeli ? "maxAmountShekel" : "maxAmountDollar"}
                                        value={campaign.isIsraeli ? campaign.maxAmountShekel : campaign.maxAmountDollar}
                                        onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted}/>
                                </div>
                                <div className="column-half">
                                </div>
                            </div>
                        </div>}
                        {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                <button className="btn btn-primary" onClick={this.onUpdate}
                                    disabled={deepEquals(this.props.campaign, this.state.campaign)}>Update</button>
                                <FadeOutErrorMessage show={this.state.error} message={this.props.message} />
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/EditCampaignModal.jsx